import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  HostBinding,
  Input,
} from '@angular/core';
import { iValidatedControl } from '../iValidatedControl';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseCustomControl } from '../baseCustomControl';

@Component({
  selector: 'app-date',
  templateUrl: './date-input.component.html',
  providers: [
    // see https://blog.thoughtram.io/angular/2016/07/27/custom-form-controls-in-angular-2.html
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateInputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class DateInputComponent
  extends BaseCustomControl
  implements ControlValueAccessor, iValidatedControl
{
  @HostBinding('class.formField') formFieldClass = true; // Always applied
  @HostBinding('class.readOnly') get isReadOnly() {
    return this.readonly;
  }

  @Input() validationLocation: string = 'right'; // right | under

  //@ViewChild('container') container:ElementRef<HTMLSelectElement>|undefined;

  selectedIndex: number = 0;

  constructor(changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override clear() {
    this.boundValue = "";
    this.actualValue = "";
  }


  ngAfterViewInit() {}

  toDateInputString(d: Date): string {
    // Normalize to UTC midnight, then slice YYYY-MM-DD
    const utc = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    return utc.toISOString().slice(0, 10);
  }

  override onValueBound() {
    if (this.boundValue && !/^\d{4}-\d{2}-\d{2}$/.test(this.boundValue)) {
      // Try to parse and normalize
      const parsed = new Date(this.boundValue.replace(/-/g, '\/').replace(/T.+/, ''));
      if (!isNaN(parsed.getTime())) {
        this.boundValue = this.toDateInputStringLocal(parsed);
        this.actualValue = this.boundValue;
      }
    }
  }

  get value(): string {
    return (this.boundValue ?? '').trim();
  }

  public clearSelection() {
    this.boundValue = undefined;
  }

  public validate(): boolean {
    this.isValid = true;
    this.validationMsg = '';

    if (this.required && this.value == '') {
      this.isValid = false;
      this.validationMsg = 'required';
    } else {
      this.isValid = true;
    }

    if (!this.isValid) {
      this._handle_validateFailed();

      if (this.validationMsg == '') {
        this.validationMsg = 'invalid';
      }
    } else {
      this._handle_validatePassed();
    }

    return this.isValid;
  }

  _handle_change(e: Event) {
    // if (this.validateOn == "change") {
    //   this.validate();
    // }

    // this.onChange(this.boundValue);
    // this.onChanged.emit(this.boundValue);
    // return true;

    const val = (e.target as HTMLInputElement).value || undefined; // "YYYY-MM-DD" or ""
    this.boundValue = val;
    this.actualValue = val;

    // Notify Angular forms
    this.onChange(val ?? '');
    this.onTouch();

    if (this.validateOn === 'change') this.validate();
    this.onChanged.emit(this.boundValue ?? '');
  }

  _handle_onBlur(e: FocusEvent) {
    this.validate();
    this.onTouch();
  }
}
